export default __webpack_public_path__ + "static/media/step-2-loop.2ff0e5bc.mp4";